import React, { useEffect } from 'react'
import {
  Redirect,
  Route,
  Switch,
  useLocation,
} from 'react-router-dom'
import { useSelector } from 'react-redux'
import Login from '../screens/auth'
import { getToken } from '../helpers/auth'
import RestrictedRoutes from './RestrictedRoutes'
import { Logout } from '../screens/logout/Logout'
import CountrySelection from '../screens/country-selection/Country-Selection'
import { pushToDataLayer } from '../utils/dataLayer'

function RoutesContainer() {
  return (
    <Switch>
      <Route path="/country-selection" render={(props) => (<CountrySelection {...props} />)} />
      <Route path="/login" render={(props) => (<Login {...props} />)} />
      <Route path="/logout" render={() => (<Logout />)} />
      <RestrictedRoute path="/" component={RestrictedRoutes} />
    </Switch>
  )
}

const selectUserCode = (state) => state.user?.user?.data?.code

const RestrictedRoute = ({ component: Component, ...rest }) => {
    const token = getToken()
    const location = useLocation()
    const user_id = useSelector(selectUserCode)

    useEffect(() => {
      if (token && user_id && location.pathname !== '/') {
        pushToDataLayer('pageView', {
          country: localStorage.getItem('country'),
          user_id,
          previousUrl: sessionStorage.getItem('previousUrl'),
          newUrl: location.pathname + location.search,
        })
        sessionStorage.setItem('previousUrl', location.pathname + location.search)
      }
    }, [location.pathname, location.search, user_id, token])

    return (
      <Route
        {...rest}
        render={(props) => (token ? (
          <Component {...props} />
      ) : (
        <Redirect
          to={{
              pathname: '/country-selection',
              state: { from: props.location },
              search: props.location.search,
            }}
        />
        ))}
      />
  )
}

export default RoutesContainer
